import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    
    // Filtre pour séparer les environnements (development vs production)
    environment: import.meta.env.MODE,

    integrations: [
        Sentry.browserTracingIntegration(),
    ],

    // Performance Monitoring
    // Capture 10% des transactions pour mesurer la performance sans exploser les quotas
    tracesSampleRate: 0.1,
});
